module.exports = __webpack_public_path__ + "img/markazi.9e843dad.png";